import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1067bd06"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1067bd06')) {
      api.createRecord('1067bd06', component.options)
    } else {
      api.reload('1067bd06', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1067bd06", function () {
      api.rerender('1067bd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/Plant/Loads/index.vue"
export default component.exports